export const newRegistration = async (signUpInfo) => {
    if(signUpInfo.firstName === '' || signUpInfo.lastName ==='' || signUpInfo.email==='' || signUpInfo.password===""){
        return ('missing information')
    }
    if(signUpInfo.password.length<6){
        return ('incorrect password length')
    }

    if(!signUpInfo.email.includes('@') || !signUpInfo.email.includes(".")){
        return ('invalid email address')
    }

    try{
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
        const response = await fetch(`${API_BASE_URL}/registerNewUser`, {
            method:'POST',
            headers:{
                'Content-Type': 'application/json',
                "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body:JSON.stringify({ firstName:signUpInfo.firstName, lastName:signUpInfo.lastName, company:signUpInfo.company, email:signUpInfo.email, password:signUpInfo.password }),
        });
        const result = await response.json();
        if(JSON.stringify(result)===`{"message":"Server error"}`){
            return ('server error')
        }
        if(JSON.stringify(result)===`{"message":"A user with that email already exists"}`){
            return ('already exists')
        }
        if(JSON.stringify(result)===`{"message":"User registered successfully"}`){
            return ('success') 
        }
        
    } 
    catch(error){
        console.error('Error: ', error)
    }
}